import * as React from 'react';

import { MotivationPopupWrapper } from '../../../components/MotivationPopup';
import { FavoriteButtonDesktopContainer } from '../../FavoriteButton';
import { MotivationPopupDesktopContainer } from '../../MotivationPopup';

export const FavoriteButtonDesktopWithMotivation: React.FC = () => {
  return (
    <MotivationPopupWrapper>
      <FavoriteButtonDesktopContainer />
      <MotivationPopupDesktopContainer />
    </MotivationPopupWrapper>
  );
};
